export default "__VITE_ASSET__Dnh58bQ9__"